import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./AllPushNotification.css";
import { useEffect, useState } from "react";
import axios from "axios";

const AllPushNotification = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [pushNotifications, setPushNotifications] = useState([]);
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/notifications?userType=${userType}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setPushNotifications(response.data.notifications);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    fetchNotifications();
  }, [API_BASE_URL, userType]);

  const handleEdit = (id) => {
    navigate(`/edit-push-notification/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/admin/notifications/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setPushNotifications((prevNotifications) =>
        prevNotifications.filter((notification) => notification._id !== id)
      );
      alert("Notification deleted successfully.");
    } catch (error) {
      console.error("Error deleting notification:", error);
      alert("Failed to delete notification. Please try again.");
    }
  };

  return (
    <>
      <div id="all-notifications-main">
        <div className="all-notifications-heading-btns">
          <h4>All Notifications</h4>
          <div className="header-main-btns">
            <button onClick={() => navigate("/push-notification")}>
              Notification
            </button>
            <button>All Notifications</button>
          </div>
        </div>
        <div className="push-notification-input">
          <label>
            <b>Notification Send - Student/Teacher</b>
          </label>
          <select
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
          >
            <option value="">All Notification</option>
            <option value="student">Student</option>
            <option value="teacher">Teacher</option>
          </select>
        </div>
        <div className="all-push-notifications-table">
          <table>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Student/Teacher</th>
                <th>Title</th>
                <th>Message</th>
                <th>Link</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {pushNotifications &&
                [...pushNotifications].reverse().map((notification, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{notification.userType}</td>
                    <td>{notification.title}</td>
                    <td>{notification.message}</td>
                    <td>
                      <a
                        href={notification.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {notification.link}
                      </a>
                    </td>
                    <td>
                      <span>
                        <FaEdit onClick={() => handleEdit(notification._id)} />
                      </span>
                      <span>
                        <MdDelete
                          onClick={() => handleDelete(notification._id)}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {pushNotifications.length === 0 && <p>No notifications found.</p>}
        </div>
      </div>
    </>
  );
};

export default AllPushNotification;
